// extracted by mini-css-extract-plugin
module.exports =  {"legend":"_2787e5dfdf--legend--RMUfa"};